import { JSX } from "react";
import "./Table.css";

interface ITableProps {
  children: JSX.Element | string;
}

const Table = ({ children }: ITableProps) => {
  return (
    <table className="table">
      <tbody>{children}</tbody>
    </table>
  );
};

export { Table };
